import { render, staticRenderFns } from "./cualificaciones.vue?vue&type=template&id=2fd42146&scoped=true"
import script from "./cualificaciones.vue?vue&type=script&lang=js"
export * from "./cualificaciones.vue?vue&type=script&lang=js"
import style0 from "./cualificaciones.vue?vue&type=style&index=0&id=2fd42146&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd42146",
  null
  
)

export default component.exports